// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_rewards__DnIYl {
  margin: 16px;
  background: rgb(117, 83, 240);
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.style_rewards__title__wcJ4p {
  font-weight: 700;
  font-size: 2.4rem;
  position: relative;
  color: rgb(247, 246, 255);
  z-index: 9;
  line-height: 20px;
  text-transform: uppercase;
  text-align: center;
  margin-top: 6px;
}
.style_rewards__subtitle__xr13c {
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 17px;
  color: rgba(255, 255, 255, 0.75);
  text-align: center;
  position: relative;
  z-index: 9;
}
.style_rewards__rules__JhChK {
  text-align: center;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 17px;
  margin: 16px 0;
  max-width: 306px;
  position: relative;
  z-index: 9;
  color: rgba(255, 255, 255, 0.75);
}

.style_tribune__4tRRP {
  display: flex;
  justify-content: center;
  position: relative;
  margin-top: 16px;
  gap: 25px;
}
.style_tribune__4tRRP img {
  position: relative;
  z-index: 9;
}
.style_tribune__main__ihYS9 {
  position: relative;
}
.style_tribune__main__sunshine__bNRR\\+ {
  position: absolute;
  top: 30%;
  left: 51%;
  transform: translate(-50%, -50%);
  z-index: 0;
}
.style_tribune__item__WbHzU {
  position: relative;
  z-index: 9;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.style_tribune__item__WbHzU img {
  width: 70px;
  height: 70px;
}
.style_tribune__item__reward__yHF7y {
  padding: 4px 8px;
  background: rgb(85, 46, 224);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
}
.style_tribune__item__title__9dMJK {
  font-size: 1rem;
  font-weight: 500;
  color: rgba(247, 246, 255, 0.75);
  line-height: 10px;
}
.style_tribune__item__amount__3AMFp {
  font-size: 1.6rem;
  color: rgb(255, 255, 255);
  font-weight: 600;
  line-height: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.style_tribune__item__amount__3AMFp img {
  width: 14px;
  height: 14px;
}
.style_tribune__default__q1Mqh {
  padding: 6px 8px;
  background: rgb(85, 46, 224);
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  width: 144px;
  margin-top: 18px;
  position: relative;
  z-index: 9;
  margin-left: auto;
  margin-right: auto;
}

.style_special__4Rspw {
  width: 100px !important;
  height: 100px !important;
}`, "",{"version":3,"sources":["webpack://./src/features/clans-war/components/clan-wars-rewards/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,6BCJK;EDKL,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;AAEE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAAJ;AAEE;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAAJ;AAGE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,gCAAA;AADJ;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;AAFF;AAGE;EACE,kBAAA;EACA,UAAA;AADJ;AAGE;EACE,kBAAA;AADJ;AAEI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AAAN;AAGE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADJ;AAEI;EACE,WAAA;EACA,YAAA;AAAN;AAGI;EACE,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AADN;AAGI;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iBAAA;AADN;AAGI;EACE,iBAAA;EACA,yBCzFE;ED0FF,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AADN;AAEM;EACE,WAAA;EACA,YAAA;AAAR;AAKE;EACE,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAOA;EACE,uBAAA;EACA,wBAAA;AAJF","sourcesContent":["@import 'public/assets/colors';\n\n.rewards {\n  margin: 16px;\n  background: $main;\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  &__title {\n    font-weight: 700;\n    font-size: 2.4rem;\n    position: relative;\n    color: rgba(247, 246, 255, 1);\n    z-index: 9;\n    line-height: 20px;\n    text-transform: uppercase;\n    text-align: center;\n    margin-top: 6px;\n  }\n  &__subtitle {\n    font-size: 1.4rem;\n    font-weight: 500;\n    line-height: 17px;\n    color: rgba(255, 255, 255, 0.75);\n    text-align: center;\n    position: relative;\n    z-index: 9;\n  }\n\n  &__rules {\n    text-align: center;\n    font-size: 1.4rem;\n    font-weight: 500;\n    line-height: 17px;\n    margin: 16px 0;\n    max-width: 306px;\n    position: relative;\n    z-index: 9;\n    color: rgba(255, 255, 255, 0.75);\n  }\n}\n\n.tribune {\n  display: flex;\n  justify-content: center;\n  position: relative;\n  margin-top: 16px;\n  gap: 25px;\n  img {\n    position: relative;\n    z-index: 9;\n  }\n  &__main {\n    position: relative;\n    &__sunshine {\n      position: absolute;\n      top: 30%;\n      left: 51%;\n      transform: translate(-50%, -50%);\n      z-index: 0;\n    }\n  }\n  &__item {\n    position: relative;\n    z-index: 9;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    img {\n      width: 70px;\n      height: 70px;\n    }\n\n    &__reward {\n      padding: 4px 8px;\n      background: rgba(85, 46, 224, 1);\n      border-radius: 10px;\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      align-items: center;\n    }\n    &__title {\n      font-size: 1rem;\n      font-weight: 500;\n      color: rgba(247, 246, 255, 0.75);\n      line-height: 10px;\n    }\n    &__amount {\n      font-size: 1.6rem;\n      color: $white;\n      font-weight: 600;\n      line-height: 16px;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      img {\n        width: 14px;\n        height: 14px;\n      }\n    }\n  }\n\n  &__default {\n    padding: 6px 8px;\n    background: rgba(85, 46, 224, 1);\n    border-radius: 10px;\n    display: flex;\n    justify-content: space-between;\n    width: 144px;\n    margin-top: 18px;\n    position: relative;\n    z-index: 9;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.special {\n  width: 100px !important;\n  height: 100px !important;\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rewards": `style_rewards__DnIYl`,
	"rewards__title": `style_rewards__title__wcJ4p`,
	"rewards__subtitle": `style_rewards__subtitle__xr13c`,
	"rewards__rules": `style_rewards__rules__JhChK`,
	"tribune": `style_tribune__4tRRP`,
	"tribune__main": `style_tribune__main__ihYS9`,
	"tribune__main__sunshine": `style_tribune__main__sunshine__bNRR+`,
	"tribune__item": `style_tribune__item__WbHzU`,
	"tribune__item__reward": `style_tribune__item__reward__yHF7y`,
	"tribune__item__title": `style_tribune__item__title__9dMJK`,
	"tribune__item__amount": `style_tribune__item__amount__3AMFp`,
	"tribune__default": `style_tribune__default__q1Mqh`,
	"special": `style_special__4Rspw`
};
export default ___CSS_LOADER_EXPORT___;
